import React, { useEffect, useState } from "react";
import MainBg from "../components/Mainbg";
import Drawer from "react-modern-drawer";
import GymView from "./Sidebar/GymView";
import { useDispatch, useSelector } from "react-redux";
import {
  refreshToken2,
  setDrawerActiveMenu,
  setIsDrawerActive,
} from "../store/features/webUtilitiesSlice";
import secureLocalStorage from "react-secure-storage";
import { GET_GOOD_READ_ENDPOINT } from "../config/ApisCollection";
import goodreadloader from "../assets/images/loaders/goodreadloader.png";
import axios from "axios";
import { useNavigate } from "react-router-dom";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

// Import Swiper styles
import "swiper/css";

const GoodRead = () => {
  const [isDrawerPopupOpen, setDrawerPopupOpen] = useState(false);
  const [workoutChoosedData, setWorkoutChoosedData] = useState(null);
  const [goodread_data, set_goodread_data] = useState(null);
  const dispatch = useDispatch();
  const accessToken = secureLocalStorage.getItem("accessToken");
  let history = useNavigate();

  const handleChangeSidebar = async (menu) => {
    await dispatch(setDrawerActiveMenu(menu));
    await dispatch(setIsDrawerActive(true));
  };
  const getGoodReadData = async () => {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split("T")[0]; // Format date as YYYY-MM-DD
    const formattedTime = currentDate.toTimeString().split(" ")[0]; // Format time as HH:MM:SS
    const request_body = {
      headers: {
        Authorization: "Bearer " + accessToken,
        CDate: formattedDate,
        CTime: formattedTime,
        "Content-Type": "application/json",
      },
      body: {},
    };

    await axios
      .get(GET_GOOD_READ_ENDPOINT, request_body)
      .then((response) => {
        setTimeout(() => {
          set_goodread_data(response.data);
        }, 2000);
      })
      .catch((error) => {
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.error &&
          error.response.data.error.message &&
          error.response.data.error.message === "token expired" &&
          secureLocalStorage.getItem("refreshToken")
        ) {
          dispatch(refreshToken2());
        } else if (error?.response?.data?.error?.message === "token expired") {
          secureLocalStorage.clear();
          history("/login");
        }
      });
  };

  const navigateHandle = (urllink) => {
    history(urllink);
    // console.log(urllink);
  };

  useEffect(() => {
    getGoodReadData();
  }, []);

  return (
    <>
      <MainBg>
        {goodread_data == null && (
          <>
            <img src={goodreadloader} className="h-72 m-auto" />
            <h1 className="text-center mt-10">loading....</h1>
          </>
        )}
        {goodread_data !== null ? (
          <div className="grid xl:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 grid-cols-1 sm:gap-20 py-20 mb-20">
            <div className="col-span-2 lg:px-10 sm:border-r-2 border-none">
              {/* <div className="">
                <input
                  type="text"
                  className="w-full border-2 border-gray-350 p-2 rounded-lg"
                  placeholder="↻ Search workouts..."
                />
              </div> */}
              <div>
                {Object.entries(goodread_data?.featuredarticle).length &&
                  Object.entries(goodread_data?.featuredarticle).length !== 0 &&
                  Object.entries(goodread_data?.featuredarticle)
                    .slice(0, 1)
                    .map((cl_row, index) => (
                      <span key={index}>
                        <div className="mt-10">
                          <h1 className="font-bold">
                            {typeof cl_row[1] === "string" ? cl_row[1] : ""}
                          </h1>
                        </div>

                        <div className="mt-2 grid xl:grid-cols-6 lg:grid-cols-5  sm:grid-cols-3 md:grid-cols-4  grid-cols-2 gap-5 ">
                          {goodread_data?.featuredarticle?.featured.map(
                            (wl_row, index) =>
                              wl_row.categorykey === wl_row.categorykey ? (
                                <div
                                  className="melasbox hover:bg-[#ffe1cb] cursor-pointer"
                                  onClick={() => {
                                    navigateHandle(
                                      "/good-read-topics/explore/" +
                                        wl_row.categorykey
                                    );
                                  }}
                                  key={index}
                                >
                                  <div>
                                    <img
                                      loading="lazy"
                                      src={wl_row.image}
                                      alt={wl_row.title}
                                      className="mealsimg h-[102px]"
                                      width={145}
                                      height={135}
                                    />
                                  </div>
                                  <div className="melalin">
                                    <div className="modesutit text-capitalize">
                                      {wl_row.contentType}
                                    </div>
                                    <div className="tabetsbol text-capitalize">
                                      {wl_row.title}
                                    </div>
                                    <hr />
                                    <div className="fastiweekboxtit">
                                      {wl_row.totalarticle + " acticles"}{" "}
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <>Not found...</>
                              )
                          )}
                        </div>
                      </span>
                    ))}
              </div>
            </div>
            <div className="flex sm:flex-row flex-col justify-center hidden">
              <div>
                <div className="cardbox sm:w-3/4 w-full bg-cover bg-center px-0">
                  <div className="mode1">
                    <img
                      className="watchImg"
                      alt="watchImg"
                      src={goodread_data?.explore?.backgroundimg}
                    />
                    <div>
                      <p className="cardboxtitle text-base">
                        {goodread_data?.explore?.title}
                      </p>
                      <p className="text-xs">
                        {goodread_data?.explore?.tagline}
                      </p>
                      <button
                        className="mt-2 light-orgn-btn rounded-lg text-[11px]"
                        onClick={() => {
                          handleChangeSidebar(314);
                        }}
                      >
                        {goodread_data?.explore?.buttonName}
                      </button>
                    </div>
                  </div>
                </div>

                <div
                  className="cardbox sm:w-3/4 w-full bg-cover bg-center px-5 py-5"
                  style={{ backgroundImage: "url('/images/bannerActive.png')" }}
                >
                  <div className="mode1">
                    {/* <img
                      className="watchImg"
                      alt="watchImg"
                      src={goodread_data?.explore?.backgroundimg}
                    /> */}
                    <div>
                      <p className="cardboxtitle text-base">
                        {goodread_data?.browsetopic?.title}
                      </p>
                      <p className="text-xs">
                        {goodread_data?.browsetopic?.tagline}
                      </p>
                    </div>
                    <button
                      className="mt-2 light-orgn-btn rounded-lg text-[11px]"
                      onClick={() => {
                        handleChangeSidebar(314);
                      }}
                    >
                      {goodread_data?.browsetopic?.buttonName}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}

        {/* {console.log(goodread_data)} */}
        <div className="mt-10">
          <h1 className="font-bold">
            {goodread_data?.recommendationarticle?.headline}
          </h1>
        </div>
        <Swiper
          modules={[Navigation, Pagination, Scrollbar, A11y]}
          slidesPerView={6}
          spaceBetween={10}
          navigation
          pagination={{ clickable: true }}
          onSwiper={(swiper) => {}}
          onSlideChange={(swiper) => {
            // console.log(swiper);
          }}
          breakpoints={{
            0: {
              slidesPerView: 1.5,
            },
            400: {
              slidesPerView: 1,
            },
            639: {
              slidesPerView: 3,
            },
            865: {
              slidesPerView: 4,
            },
            1000: {
              slidesPerView: 5,
            },
            1500: {
              slidesPerView: 6,
            },
            1700: {
              slidesPerView: 6,
            },
          }}
        >
          {goodread_data?.recommendationarticle != null &&
            Object.entries(goodread_data?.recommendationarticle).length &&
            Object.entries(goodread_data?.recommendationarticle).length !== 0 &&
            Object.entries(goodread_data?.recommendationarticle.articles).map(
              (rec_row, index) => (
                <SwiperSlide key={index}>
                  {" "}
                  <div
                    className="melasbox cursor-pointer hover:bg-[#ffe1cb]"
                    onClick={() => {
                      navigateHandle(
                        "/good-read-topics/explore/" + rec_row[1].category
                      );
                    }}
                  >
                    <div>
                      <img
                        loading="lazy"
                        src={rec_row[1].blogimage}
                        alt={rec_row[1]?.title?.slice(0, 25)}
                        className="mealsimg h-[152px]"
                      />
                    </div>
                    <div className="melalin">
                      <div className="modesutit text-capitalize">
                        {rec_row[1].category}
                        {/* {rec_row[1].categorykey} */}
                      </div>
                      <div className="tabetsbol text-capitalize">
                        {rec_row[1]?.title?.slice(0, 25)}
                      </div>
                      <hr />
                      <div className="fastiweekboxtit">
                        {rec_row[1].subCategory + " "}{" "}
                      </div>
                    </div>
                  </div>
                  {/* {console.log(rec_row)} */}
                </SwiperSlide>
              )
            )}
        </Swiper>
        <br />
        <br />
        <br />
      </MainBg>

      <Drawer
        open={isDrawerPopupOpen}
        direction="right"
        lockBackgroundScroll={false}
        className={`manlay !p-5 !pb-10 sm:!w-96 !w-80 !overflow-y-scroll !overflow-x-hidden !rounded-l-3xl !border-none`}
        onClose={() => {
          setDrawerPopupOpen(false);
        }}
      >
        <GymView workoutChoosedData={workoutChoosedData} />
      </Drawer>
    </>
  );
};
export default React.memo(GoodRead);
